module.exports = __webpack_public_path__ + "media/images/gifts/autonomy/sug_autonomia_2-b9791359152af8268bef91ee82bdcf37.jpg";